import React, { useState, useEffect } from 'react';

export default function SugarValuePicker({ onValueChange, initialValue = 100 }) {
  const [value, setValue] = useState(initialValue);

  // Update parent component when value changes
  useEffect(() => {
    if (onValueChange) {
      onValueChange(value);
    }
  }, [value, onValueChange]);

  const adjustValue = (delta) => {
    setValue(prev => Math.max(0, prev + delta)); // Prevent negative values
  };

  const buttonStyle = {
    padding: '8px 12px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: '#36a2eb',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'background-color 0.2s',
    minWidth: '60px'
  };

  const buttonHoverColor = '#2591d9';

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      border: '2px solid #e9ecef'
    }}>
      {/* Left Button Stack */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          style={buttonStyle}
          onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverColor}
          onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
          onClick={() => adjustValue(-100)}
        >
          -100
        </button>
        <button
          style={buttonStyle}
          onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverColor}
          onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
          onClick={() => adjustValue(-10)}
        >
          -10
        </button>
        <button
          style={buttonStyle}
          onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverColor}
          onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
          onClick={() => adjustValue(-1)}
        >
          -1
        </button>
      </div>

      {/* Center Value Display */}
      <div style={{
        fontSize: '32px',
        fontWeight: '700',
        color: '#36a2eb',
        fontFamily: 'monospace',
        minWidth: '100px',
        textAlign: 'center',
        padding: '16px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '2px solid #36a2eb'
      }}>
        {value}
      </div>

      {/* Right Button Stack */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          style={buttonStyle}
          onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverColor}
          onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
          onClick={() => adjustValue(+100)}
        >
          +100
        </button>
        <button
          style={buttonStyle}
          onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverColor}
          onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
          onClick={() => adjustValue(+10)}
        >
          +10
        </button>
        <button
          style={buttonStyle}
          onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverColor}
          onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
          onClick={() => adjustValue(+1)}
        >
          +1
        </button>
      </div>
    </div>
  );
}
